import Ticker from './Ticker.jsx';

export default Ticker;